import React, { Component } from 'react';
import ScreenAlertModal from './ScreenAlertModal.react.js';
import PrinterStatusModal from './PrinterStatusModal.react.js';
import PurchaseLicenseModal from './PurchaseLicenseModal.react.js';
import Tooltips from './Tooltips.react.js';
import HelpModal from './HelpModal.react.js';
import ConsultationModal from './ConsultationModal.react.js';
import Header from './Header.react.js';
import Overview from './Overview.react.js';
import OrderView from './OrderView.react.js';
import TableView from './TableView.react.js';
import NotificationCenter from './NotificationCenter.react.js';
import SettingsView from './SettingsView.react.js';
import MobileOrderModal from './modal/MobileOrderModal.react.js';
import ChooseMemberModal from './modal/ChooseMemberModal.react.js';
import PaymentNotesModal from './modal/PaymentNotesModal.react.js';

import classNames from 'classnames';
let i18n = require("i18next");

export default class TooieApp extends Component {
    baseFeatures() {
        return (
            <div>
                <Overview showDemoBtn={this.props.showGenerateDemoBtn} isExp={this.props.isExpRest} />
                <TableView isExp={this.props.isExpRest} />
                <OrderView isExp={this.props.isExpRest} />
                <NotificationCenter {...this.props} />
                <div id="cashier" className={classNames('state', 'hidden', {experienceRestaurantDialogBottom: this.props.isExpRest})}>
                </div>
                <div id="sales" className={classNames('state', 'hidden', {experienceRestaurantDialogBottom: this.props.isExpRest})}>
                    <div className="mainArea">
                    </div>
                    <div className="loading hidden">
                        <img src={require("../images/loading_big.gif")}/>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div>
                    {this.props.hasBaseFeature ? this.baseFeatures(): null}
                    <SettingsView {...this.props} />
                </div>
                <Header {...this.props} />
                <audio id="audioAlert" preload="auto">
                    <source src="../audio/alert.ogg"/>
                </audio>
                {this.props.showConsultNotContact ? <ConsultationModal workDay={this.props.workDay} nextDays={this.props.nextDays}/> : null}
                <ScreenAlertModal />
                <PrinterStatusModal />
                <PurchaseLicenseModal charges={this.props.charges}/>
                <MobileOrderModal registerUrl={this.props.registerUrl} staffs={this.props.staffs} />
                <ChooseMemberModal staffs={this.props.staffs} />
                <PaymentNotesModal paymentNotes={this.props.paymentNotes} />
                <HelpModal locale={this.props.locale} firstLogin={this.props.firstLogin} />
                <Tooltips />

                <div id="notification" className="hidden">
                    <div className="notification-container">
                        <div className="notification-center">
                            <div className="header">{i18n.t("pos.notification.name.center")}</div>
                            <div className="body">
                                <div className="palette">
                                    <img className="selected-all"
                                         src={require("../images/notifications/uncheck.png")}/>
                                    <span className="action">{i18n.t("pos.notification.name.theme")}</span>
                                        <span className="action">
                                            <div className="drop-action"><span>{i18n.t("pos.notification.name.mark")}<img className="mark-notice"
                                                                                       src={require("../images/notifications/dropdown.png")}/></span>
                                            </div>
                                            <div className="mark-dropdown hidden">
                                                <div className="state-read" data-status="Read"><img
                                                    src={require("../images/notifications/uncheckRead.png")}/>{i18n.t("pos.notification.name.read")}
                                                </div>
                                                <div className="state-unread" data-status="Unread"><img
                                                    src={require("../images/notifications/uncheckedUnread.png")}/>{i18n.t("pos.notification.name.unread")}
                                                </div>
                                            </div>
                                        </span>
                                    <span className="action delete-message">{i18n.t("pos.notification.name.delete")}</span>
                                </div>
                                <div className="notifications">
                                    <div className="no-message hidden">{i18n.t("pos.notification.name.noMessage")}</div>
                                    <ul className="notification-ul">
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="bigLoading">
                    <img src={require("../images/loading_big.gif")} height="64" width="64"/>
                </div>

                <div id="guideView" className="hidden">
                    <div className="mask"></div>
                </div>

                <div className="saveSuccessDiv hidden">
                    <div className="save saveSuccessAlert">
                        <img
                            src={require("../images/pos/settings/saveSuccess.png")}/>&nbsp;{i18n.t("pos.setting.settingSaved")}
                    </div>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/TooieApp.react.js